import error from './Error';
import text from './text';
import chatbot from './chatbot';
import usaSms from './usaSms';
import recurrence from './recurrence';
import setNumber from './setNumber';
import invoices from './invoices';

export default {
  error,
  text,
  chatbot,
  usaSms,
  recurrence,
  invoices,
  setNumber
};
